import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import StatCard from 'componentsv2/common/StatCard';
import { numberWithCommas } from 'utils/NumberCommaSeprator';

const money = (value) =>
	value === null || value === undefined ? '—' : `₹ ${numberWithCommas(Math.round(value))}`;

const count = (value) =>
	value === null || value === undefined ? '—' : numberWithCommas(Math.round(value));

/**
 * The four KPI tiles, shared by the portfolio and per-project views.
 *
 * Takes an already-normalised summary (see `normalizePortfolio` /
 * `normalizeProjectFigures`) so both callers feed it the same shape.
 */
export default function WarehouseKpiRow({ summary, loading }) {
	const data = summary || {};
	const { marginAbs, marginPct, shipmentCount } = data;

	const hasMargin = marginAbs !== null && marginAbs !== undefined;
	const marginTone = hasMargin && Number(marginAbs) < 0 ? 'danger' : 'success';

	return (
		<Row gutter={[16, 16]}>
			<Col xs={24} sm={12} xl={6}>
				<StatCard
					label="MTD Revenue"
					value={money(data.revenue)}
					sub={
						shipmentCount === null || shipmentCount === undefined
							? null
							: `${count(shipmentCount)} shipments processed`
					}
					loading={loading}
				/>
			</Col>

			<Col xs={24} sm={12} xl={6}>
				<StatCard
					label="MTD Cost (excl. monthly)"
					value={money(data.costExclMonthly)}
					sub="Fixed + daily actuals"
					loading={loading}
				/>
			</Col>

			<Col xs={24} sm={12} xl={6}>
				<StatCard
					label="MTD Cost (incl. monthly)"
					value={money(data.costInclMonthly)}
					sub="Approximate — pending monthly heads use last month's value"
					subTone="warning"
					loading={loading}
				/>
			</Col>

			<Col xs={24} sm={12} xl={6}>
				<StatCard
					label="Margin"
					value={
						hasMargin
							? `${money(marginAbs)} · ${Number(marginPct).toFixed(1)}%`
							: /* Keep "no data" distinct from a genuine 0% margin */ '—'
					}
					tone={hasMargin ? marginTone : 'default'}
					sub="Against MTD cost incl. monthly"
					loading={loading}
				/>
			</Col>
		</Row>
	);
}

WarehouseKpiRow.propTypes = {
	summary: PropTypes.object,
	loading: PropTypes.bool,
};

WarehouseKpiRow.defaultProps = {
	summary: null,
	loading: false,
};
